import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { filter, of, switchMap, withLatestFrom } from "rxjs";
import { documentViewActions } from "../document-view/document-view.actions";
import { currentActionPanelView } from "./action-panel.selectors";
import { actionPanelActions } from "./action-panel.actions";
import { DocumentViewToActionPanelSyncMap } from "@models/mappers/maps/document-view-to-action-panel-sync.map";

@Injectable()
export class ActionPanelEffects {
	public viewPanelSync$ = createEffect(() => this.actions$.pipe(
		ofType(documentViewActions.viewInitialized, documentViewActions.viewUpdated),
		filter((props) => DocumentViewToActionPanelSyncMap.has(props.selectedView)),
		withLatestFrom(this.store.select(currentActionPanelView())),
		switchMap(([viewProps, currentActionPanel]) => {
			const targetActionPanel = DocumentViewToActionPanelSyncMap.get(viewProps.selectedView);
			if (currentActionPanel !== targetActionPanel)
				this.store.dispatch(actionPanelActions.viewUpdated({ selectedView: targetActionPanel }));
			return of({ type: 'noop' });
		})
	));

	constructor(
		private actions$: Actions,
		private store: Store
	) {
	}
}